import React, { useMemo, useState, useEffect } from "react";
import {
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { LoginMenu } from "./api-authorization/LoginMenu";
import AdminFunctions from "./admin/AdminFunctions";
import AuthFunctions from "./services/AuthService";
import Session from "./auth/Session";
import "./SidebarNav.css";

export const SidebarNav = ({
  brandImgSrc = "CVNlogo.png",
  brandImgAlt = "logo",
}) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState("");

  const toggleMobile = () => setIsMobileOpen((v) => !v);

  const closeOnNavigate = useMemo(
    () => ({
      onClick: () => setIsMobileOpen(false),
    }),
    []
  );

  useEffect(() => {
    let mounted = true;

    (async () => {
      const authed = await AuthFunctions.getAuthenticatedAsync();
      if (!mounted) return;
      setIsAuth(authed);

      if (authed) {
        const admin = await AdminFunctions.isAdminAsync();
        if (!mounted) return;

        // get role
        setRole(Session.getRole());
        setIsAdmin(admin);
      } else {
        setIsAdmin(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const SidebarContent = () => (
    <div className="sidebar-inner d-flex flex-column h-100">
      {/* Brand row INSIDE the offcanvas/sidebar (not in the mobile top bar) */}
      <div className="p-3 d-flex align-items-center justify-content-center">
        <img src={brandImgSrc} alt={brandImgAlt} className="sidebar-brand-img" />
      </div>

      <div className="sidebar-body d-flex flex-column flex-grow-1 p-3">
        {isAuth && (
          <Nav vertical className="sidebar-nav-main">
            {isAdmin && (
              <>
                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/users" end className="sidebar-link" {...closeOnNavigate}>
                    Users
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/equipment" end className="sidebar-link" {...closeOnNavigate}>
                    Equipment
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/vehicle/assignments" end className="sidebar-link" {...closeOnNavigate}>
                    Vehicle Assignments
                  </NavLink>
                </NavItem>
              </>
            )}

            {(isAdmin || role === "Project Manager") && (
              <>
                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/job-listings" end className="sidebar-link" {...closeOnNavigate}>
                    Job Listings
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/schedule-jobs" end className="sidebar-link" {...closeOnNavigate}>
                    Schedule Jobs
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={RRNavLink} to="/daily-schedule" end className="sidebar-link" {...closeOnNavigate}>
                    Daily Schedule
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={RRNavLink} to="/time-review" end className="sidebar-link" {...closeOnNavigate}>
                    Time Review
                  </NavLink>
                </NavItem>
              </>
            )}

            {role !== "Admin" && role !== "Project Manager" && (
              <NavItem>
                <NavLink tag={RRNavLink} to="/daily-schedule" end className="sidebar-link" {...closeOnNavigate}>
                  Daily Schedule
                </NavLink>
              </NavItem>
            )}

            {role !== "Admin" && (
              <NavItem>
                <NavLink tag={RRNavLink} to="/time-entry" end className="sidebar-link" {...closeOnNavigate}>
                  Time Entry
                </NavLink>
              </NavItem>
            )}

            {role === "Admin" && (
                <NavItem>
                  <NavLink tag={RRNavLink} to="/admin/audit" end className="sidebar-link" {...closeOnNavigate}>
                    Audit
                  </NavLink>
                </NavItem>
            )}
          </Nav>
        )}

        <div className="sidebar-nav-auth mt-auto pt-3">
          <LoginMenu {...closeOnNavigate} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* MOBILE TOP BAR: hamburger only */}
      <Navbar light className="mobile-topbar d-md-none">
        <NavbarToggler
          onClick={toggleMobile}
          className="mobile-hamburger"
          aria-label="Open menu"
        />
      </Navbar>

      {/* DESKTOP SIDEBAR */}
      <aside className="sidebar-nav border-end bg-white d-none d-md-flex">
        <SidebarContent />
      </aside>

      {/* MOBILE OVERLAY SIDEBAR */}
      <Offcanvas
        isOpen={isMobileOpen}
        toggle={toggleMobile}
        direction="start"
        className="mobile-offcanvas d-md-none"
      >
        <OffcanvasHeader toggle={toggleMobile} className="px-3"></OffcanvasHeader>
        <OffcanvasBody className="p-0">
          <SidebarContent />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};
